// ─── Shared utilities: formatting, dates, containers, uid ─────────────────────
const _MONTH_NAMES = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
function _mkKey(y, m) { return `${y}-${String(m).padStart(2,"0")}`; }
function _getDaysInMonth(y, m) { return new Date(y, m, 0).getDate(); }
function _addDays(date, days) { return new Date(date.getTime() + days * 86_400_000); }
function _dateFromKey(key) { const [y,m]=key.split("-").map(Number); return {year:y,month:m}; }
export function isMonthKey(key) { return /^\d{4}-\d{1,2}$/.test(key); }

export const MONTH_NAMES = _MONTH_NAMES;

// ─── Unit system helpers — reads window.__sfUnits / window.__sfCurrency ────────
export function _currency()  { return (typeof window !== "undefined" && window.__sfCurrency)  || "EUR"; }
export function _unitSys()   { return (typeof window !== "undefined" && window.__sfUnits)     || "metric"; }

export function cbmToDisplay(cbm) {
  if (_unitSys() === "imperial") return Math.round(cbm * 35.3147) + " ft³";
  return cbm + " CBM";
}
export function currSym() { const c = _currency(); return c === "USD" ? "$" : c === "GBP" ? "£" : "€"; }
export function volumeLabel() {
  return _unitSys() === "imperial" ? "ft³" : "CBM";
}

export const CONTAINER_TYPES = [
  { id: "20std", label: "20' Standard (20GP)", cbm: 25 },
  { id: "40std", label: "40' Standard (40GP)", cbm: 55 },
  { id: "40hc",  label: "40' High Cube (40HQ)", cbm: 67 },
  { id: "45hc",  label: "45' High Cube (45HQ)", cbm: 79 },
];

// ─── Date helpers ─────────────────────────────────────────────────────────────
export const getDaysInMonth = _getDaysInMonth;
export function parseDate(s) {
  if (!s) return null;
  const p = s.split(".");
  if (p.length !== 3) return null;
  const d = new Date(parseInt(p[2]), parseInt(p[1]) - 1, parseInt(p[0]));
  return isNaN(d.getTime()) ? null : d;
}
export function toDateStr(y, m, d) {
  return `${String(d).padStart(2,"0")}.${String(m).padStart(2,"0")}.${y}`;
}
export const mkKey = _mkKey;
export const addDays = _addDays;
export const dateFromKey = _dateFromKey;

// ─── Formatting ───────────────────────────────────────────────────────────────
export function fmt(n) {
  if (n === undefined || n === null || isNaN(n)) return currSym() + "0";
  const sym = currSym();
  const a = Math.abs(n);
  let s;
  if (a >= 1e6) s = (a / 1e6).toFixed(1) + "M";
  else if (a >= 1000) s = (a / 1000).toFixed(1) + "K";
  else s = a.toFixed(0);
  return (n < 0 ? "-" + sym : sym) + s;
}
export function fmtFull(n) {
  if (n === undefined || n === null || isNaN(n)) return currSym() + "0";
  const sym = currSym();
  return (n < 0 ? "-" + sym : sym) + Math.abs(n).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

// ─── UID generator ────────────────────────────────────────────────────────────
let _ctr = 1000;
export function uid() { _ctr++; return `id_${_ctr}_${Date.now()}`; }

// ─── Validate date string DD.MM.YYYY ─────────────────────────────────────────
export function validateDateStr(s) {
  if (!s) return null;
  const p = s.split(".");
  if (p.length !== 3) return "Use format DD.MM.YYYY";
  const [d, m, y] = p.map(Number);
  if (isNaN(d) || isNaN(m) || isNaN(y)) return "Invalid date — use DD.MM.YYYY";
  if (m < 1 || m > 12) return "Month must be 1–12";
  if (d < 1 || d > 31) return "Day must be 1–31";
  if (y < 2020 || y > 2035) return "Year seems incorrect";
  const date = new Date(y, m - 1, d);
  if (date.getMonth() !== m - 1) return "Invalid date for this month";
  return null; // null = valid
}

// ─── CBM / Container calculations ────────────────────────────────────────────
export function calcContainersFromCbm(totalCbm, containerType) {
  const ct = CONTAINER_TYPES.find(c => c.id === containerType) || CONTAINER_TYPES[2];
  return Math.ceil(totalCbm / ct.cbm);
}
export function calcCbmFromContainers(qty, containerType, cbmOverride) {
  if (cbmOverride) return cbmOverride * qty;
  const ct = CONTAINER_TYPES.find(c => c.id === containerType) || CONTAINER_TYPES[2];
  return ct.cbm * qty;
}
export function getOrderTotalCt(order) {
  return (order.containerLines || []).reduce((s, l) => s + (l.qty || 0), 0) || (order.totalContainers || 0);
}
